import { Component, forwardRef, OnInit } from '@angular/core';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { LoanDao } from '@app/dao/loan/loan.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { Subject } from 'rxjs';
import { EaLoanCapacityFormBuilder } from './ea-loan-capacity-form.builder';

@Component({
    selector: 'ea-loan-capacity-form',
    templateUrl: './ea-loan-capacity-form.component.html',
    styleUrls: ['./ea-loan-capacity-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaLoanCapacityFormComponent),
        },
    ],
    standalone: false
})
export class EaLoanCapacityFormComponent
  extends EaLoanCapacityFormBuilder
  implements OnInit
{
  private user: UserAuthentified;
  doneSubject: Subject<void> = new Subject<void>();

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private loanDao: LoanDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.userDao.getAuthentified().subscribe(user => {
      this.user = user;
    });
  }

  onSubmit() {
    this.prFormService.loading();
    this.loanDao
      .computeLoanCapacity(this.user.accountId, this.extract())
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La simulation a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La simulation a échoué');
        },
      );
  }
}
